import { useState } from "react";
import { PanelFlow } from "components/PanelFlow";
import { IssueKeyType } from "model";

import { panels } from "./ReportIssuePanels";
import { ReportIssueKey, ReportIssueModalProps } from "./types";

type ModelStateProps = {
  reportedIssues: IssueKeyType[];
  initialIntervalId?: number;
};

export default function ReportIssueModal({ extraProps, onDismiss }: ReportIssueModalProps) {
  const { subName, subId, intervals, status, requestId, initialState, school } = extraProps;

  const [issues, setIssues] = useState<ModelStateProps>({
    reportedIssues: [],
    initialIntervalId: initialState?.initialSelectedIntervalId,
  });

  return (
    <PanelFlow
      defaultPanelKey={initialState?.initialPanel || ReportIssueKey.ReportIssueFormPanel}
      state={issues}
      setState={setIssues}
      panels={panels}
      extraProps={{
        subName,
        subId,
        intervals,
        onDismiss,
        status,
        requestId,
        school,
      }}
    />
  );
}
